"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
function SvgWifi(props) {
    return ((0, jsx_runtime_1.jsxs)("svg", __assign({ viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: [(0, jsx_runtime_1.jsx)("path", { d: "M20 33a3 3 0 110-6 3 3 0 110 6z", fill: "currentColor" }, void 0), (0, jsx_runtime_1.jsx)("path", { d: "M9 21c2.653-3.06 6.6-5 11.007-5 4.4 0 8.34 1.934 10.993 4.985M5 16c3.74-3.692 9.077-6 15-6s11.26 2.308 15 6M26 25c-1.406-1.826-3.569-3-6-3s-4.594 1.174-6 3", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }, void 0)] }), void 0));
}
exports.default = SvgWifi;
//# sourceMappingURL=Wifi.js.map